import { IMutations } from './mutations.types'
import { IMigrationImport } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    setMigrationData(state: IMigrationImport, payload: any) {
        var importData = {}
        if (payload) {
            state.Schema = payload.otherInfo.Schema
            state.GrantSchema = payload.otherInfo.GrantSchema
            state.Indicators = payload.otherInfo.Indicators
            state.Users = payload.otherInfo.Users;
            state.Tags = payload.otherInfo.DocumentTags;
            state.Currencies = payload.otherInfo.Currencies;
            //let data = payload.MigrationImport.ImportData ? JSON.parse(payload.MigrationImport.ImportData) : importData
            state.ImportData = payload.importData
            state.ImportData['applicationBudget'] = payload.importData.applicationBudget
            state.ImportData['grant'] = payload.importData.grant ? payload.importData.grant : {}
            state.GrantCode = payload.otherInfo.MigrationImport.GrantCode
            state.GrantStatusId = payload.otherInfo.MigrationImport.GrantStatusId
            state.InitiativeCallId = payload.otherInfo.MigrationImport.InitiativeCallId
            state.MigrationImportId = payload.otherInfo.MigrationImport.MigrationImportId
            state.ProgramId = payload.otherInfo.MigrationImport.ProgramId
            state.WorkflowStatusId = payload.otherInfo.MigrationImport.WorkFlowStatusId
            state.Impact = payload.otherInfo.Impact
            state.Currency= payload.otherInfo.Currency
            state.BudgetCategories= payload.otherInfo.BudgetCategories
            state.ProgramOfficerId= payload.otherInfo.MigrationImport.ProgramOfficerId
            state.IsFixedIndirectCost= payload.otherInfo.IsFixedIndirectCost
            state.IndirectCost= payload.otherInfo.IndirectCost
        }
    },
    addIndicator(state: IMigrationImport, payload: any): void {
        state.Indicators.push(payload);
    },
    updateIndicator(state: IMigrationImport, payload: any): void {
        var indicator = state.Indicators.find(x => x.ID === payload.ID);
        var index = state.Indicators.indexOf(indicator);
        state.Indicators[index] = indicator;
    },
}
